import { SendPlusFill, ThreeDotsVertical } from "react-bootstrap-icons";
import TableHeader from "../Components/TableHeader";
import OutsideClickHandler from "react-outside-click-handler";
import TableLoader from "../Components/TableLoader";
import TableFoot from "../Components/TableFoot";
import DialogModal from "../Components/DialogModal";
import { useState } from "react";
import core from "../core"
import { useEffect } from "react";
import axios from "axios";
import AddNewNotification from "../Components/AddNewNotification";


const Notifications = ({setNotification}) => {
    const query = core.useQuery();
    const [active, setActive] = useState("");
    const [total, setTotal] = useState(0);
    const [dialog, setDialog] = useState({title: "", text: '', show: "", id: "", loader: false});
    const [modals, setModals] = useState({createNotification: false, deleteNotification: false});
    const [loading, setLoading] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [filter, setFilter] = useState({page: query.page ? query.page : "1", limit: query.limit ? query.limit : "10", keyword: query.keyword ? query.keyword : "", 
        sort_by: query.sort_by ? query.sort_by : "id", sort_order: query.sort_order ? query.sort_order : "DESC", auction: query.auction ? query.auction : ""});
    const checkboxes = [];
    const [reRender, setReRender] = useState(0);
    const [action, setAction] = useState("add");
    const [sortBy, setSortBy] = useState([]);
    const [formData, setFormData] = useState({title: "", html: "", alert_type: "", users: []});

    const handlers = {
        addNewHandler(){
            setModals((prev) => ({...prev, createNotification: true}));
        },
        openEditNotificationModal(acc){
            setActive("");
            setModals((prev) => ({...prev, createNotification: true}));
            const u = typeof acc.users == "string" ? JSON.parse(acc.users).map((user) => ({label: user.user, value: user.user})) : acc.users.map((user) => ({label: user.user, value: user.user}));
            setFormData({
                title: acc.title, html: acc.html, alert_type: acc.alert_type, id: acc.id, users: u
            });
            setAction("edit");
        },
        openDeleteNotificationModal(acc){
            setDialog({show: true, title: "Delete notification", text: "Do you want to remove this notification?", id: acc.id, loader: false});
            setActive("");
        },
        removeNotification(){
            setDialog((prev) => ({...prev, loader: true}));
            axios.delete(`/api/extension/v1/notifications/${dialog.id}`)
                .then((res) => {
                    const data = res.data;
                    setNotification({show: true, type: "success", text: data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setReRender((prev) => prev + 1);
                    setDialog({show: false, title: "", text: "", id: "", loader: false})
                })
                .catch((err) => {
                    setNotification({show: true, type: "success", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                })
        }
    }

    useEffect(() => {
        axios('/api/extension/v1/options?name=accounts-sort-by')
            .then((res) => {
                const data = res.data.data;
                setSortBy(typeof data == "string" ? JSON.parse(data) : data);
            })
        setLoading(true);
        axios.get(`/api/extension/v1/admin-access/notifications?keyword=${filter.keyword}&page=${filter.page}&limit=${filter.limit}&sort_by=${filter.sort_by}&sort_order=${filter.sort_order}`)
            .then(res => {
                setNotifications(res.data.data);
                setTotal(res.data.total);
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
            })
    }, [filter, reRender])

    return(
        <div className="page-content-container">
            <h2 className="page-title">Notifications</h2>
            <TableHeader addNewHandler={handlers.addNewHandler} setNotification={setNotification} AddNewButtonIcon={SendPlusFill} setModals={setModals} filter={filter} sortBy={sortBy} exportButton={false} checkboxes={checkboxes} setFilter={setFilter} />
            <table className="responsive-d-table">
                <thead>
                    <tr>
                        <th style={{width: "33px"}}><input style={{cursor: "pointer"}} type="checkbox"  onChange={(e) => {
                            if(e.target.checked){

                            }else{

                            }
                        }} /></th>
                        <th>Title</th>
                        <th>Message</th>
                        <th>Type</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        (!loading && notifications.length > 0) && notifications.map((alrt, id) => {
                            return <tr key={alrt.id} className={(id + 2) % 2 == 0 ? "even-row" : "odd-row"}>
                                <td><input type="checkbox" /></td>
                                <td>{alrt.title}</td>
                                <td title={alrt.html}>{alrt.html.slice(0, 50)}</td>
                                <td><div className="alert-type-box" style={{background: alrt.alert_type}}></div></td>
                                <td>
                                    <ThreeDotsVertical onClick={() => setActive(alrt.id)} style={{color: "white", fontSize: "18px", cursor: "pointer"}} />
                                    {active == alrt.id && <OutsideClickHandler onOutsideClick={() => setActive("")}>
                                        <div className="table-actions-box">
                                            <ul>
                                                <li onClick={() => handlers.openEditNotificationModal(alrt)}>Edit</li>
                                                <li onClick={() => handlers.openDeleteNotificationModal(alrt)}>Delete</li>
                                            </ul>
                                        </div>    
                                    </OutsideClickHandler>}
                                </td>
                            </tr>
                        })
                    }
                    {
                        (!loading && notifications.length == 0) && <tr style={{background: "#494646ff"}}>
                            <td colSpan={5}><div className="empty-records"><span>Records not found</span></div></td>
                        </tr>
                    }
                    {
                        loading && <TableLoader colspan={5}/>
                    }
                </tbody>
            </table>
            <TableFoot  filter={filter} setFilter={setFilter} count={total} />
            <DialogModal show={dialog.show} setShow={() => setDialog((prev) => ({...prev, show: false}))} title={dialog.title} text={dialog.text} onSubmit={handlers.removeNotification} loader={dialog.loader} />
            <AddNewNotification show={modals.createNotification} setShow={setModals} formData={formData} action={action} setFormData={setFormData} setNotification={setNotification} setReRender={setReRender} />
        </div>
    )
}

export default Notifications